export default __webpack_public_path__ + "static/media/macro-mobile.8de3689f.png";